import { render, staticRenderFns } from "./address-query.vue?vue&type=template&id=6d104d78&scoped=true&"
import script from "./address-query.vue?vue&type=script&lang=js&"
export * from "./address-query.vue?vue&type=script&lang=js&"
import style0 from "./address-query.vue?vue&type=style&index=0&id=6d104d78&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d104d78",
  null
  
)

export default component.exports